"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function locateAutoTelLink(value, fromIndex) {
    return value.indexOf('tel:', fromIndex);
}
function tokenizeAutoTelLink(eat, value, silent) {
    var match = /^tel:(\(?0\d{1,3}\)?[-(]?\d{1,4}[-)]?\d{3,4})/.exec(value);
    if (match) {
        if (silent) {
            return true;
        }
        return eat(match[0])({
            type: 'link',
            url: 'tel:' + match[1],
            children: [{ type: 'text', value: match[1] }]
        });
    }
}
tokenizeAutoTelLink.notInLink = true;
tokenizeAutoTelLink.locator = locateAutoTelLink;
function autoTelLink() {
    var Parser = this.Parser;
    var tokenizers = Parser.prototype.inlineTokenizers;
    var methods = Parser.prototype.inlineMethods;
    tokenizers.autoTelLink = tokenizeAutoTelLink;
    methods.splice(methods.indexOf('autoLink'), 0, 'autoTelLink');
}
exports.default = autoTelLink;
//# sourceMappingURL=autoTelLink.js.map